import React, { Component } from 'react';
import closeIcon from '../../../assets/icons/icon_close.svg';

var classNames = require('classnames');

class UserInput extends Component{
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      infoActive: false
    }
  }

  handleChange(e) {
    var value = e.target.value;
    if(value === ''){
      value = 0
    }
    const name = this.props.name;
    this.props.onChange(value, name);
  }

  componentWillMount() {
    this.props.onChange(this.props.value, this.props.name)
  }

  handleInfoModal = () => {
    const infoModal = this.refs.infoModal;
    const activeState = this.state.infoActive;
    const section = this.refs.section;
    if (infoModal !== undefined && section !== undefined){
      if(activeState){
        infoModal.classList.remove(this.props.styles.infoModalActive)
        section.classList.remove(this.props.styles.containerRotate)
        this.setState({
          infoActive: false
        })
      }
      else{
        infoModal.classList.add(this.props.styles.infoModalActive)
        section.classList.add(this.props.styles.containerRotate)
        this.setState({
          infoActive: true
        })
      }
      
    }
  }
  
  render() {
    const styles = this.props.styles;
    const separator = (this.props.currency !== undefined && this.props.unitInfo ) ? " / " : "";

    return(
      <div ref="section" className={classNames(styles.inputItem, styles.inputColour)}>
        <div className={styles.info}>
          {this.props.helpText &&
            <div>
              <img src={this.props.icon} alt="Info" onMouseDown={this.handleInfoModal} />
              <div className={styles.infoModal} ref="infoModal" onMouseDown={this.handleInfoModal}>
                <h5>{this.props.description}</h5>
                <p>{this.props.helpText}</p>
                <img src={closeIcon} alt="Info" onMouseDown={this.handleInfoModal} />
              </div>
            </div>
          }
        </div>
        <input
          className={styles.inputField}
          type="number"
          //defaultValue={parseFloat(this.props.value).toFixed(2)}
          value={this.props.value}
          name={this.props.name}
          onChange={this.handleChange}
        />
        <span>
          {this.props.currency !== undefined && this.props.currency.symbol} {separator} {this.props.unitInfo}
        </span>
        <span className={styles.bottom}>
          {this.props.description}
        </span>
      </div>
    );
  }
}

export default UserInput;



// WEBPACK FOOTER //
// ./src/components/calculator/inputs/c_user_input.js